/* eslint-disable */
<template>
  <!-- eslint-disable-next-line no-mixed-spaces-and-tabs -->
  <div>
      {{ pageUrl }}
  </div>
</template>

<!-- 第一个script块：注释放在块内顶部 -->
<script>
/* eslint-disable-next-line no-mixed-spaces-and-tabs */
export default {
    name: 'PublicPage',
}
</script>

<!-- script setup块：注释放在块内顶部，覆盖下方所有代码 -->
<script setup>
/* eslint-disable-next-line no-mixed-spaces-and-tabs */
import { ref, onMounted } from 'vue'
const pageUrl = ref('')

// callJS 已经在 main.js 中全局定义，这里不再需要定义

function getPageUrl() {
  const getPageUrl = JSON.stringify({
    func: 'getPageUrl',
  })
  if (window.android) {
    window.android.callNative(getPageUrl)
  }
}

function getToken() {
  const tokenRequest = JSON.stringify({
    func: 'getToken',
  })
  if (window.android) {
    window.android.callNative(tokenRequest)
  }
}

onMounted(() => {
  // 使用全局 callJS（已经在 main.js 中设置）
  // 先获取 token（会获取 host），再获取 pageUrl
  if (window.getToken) {
    window.getToken()
  } else {
    getToken()
  }
  // 延迟获取 pageUrl，确保 host 已设置
  setTimeout(() => {
    if (window.getPageUrl) {
      window.getPageUrl()
    } else {
      getPageUrl()
    }
  }, 100)
})
</script>

<style scoped>
/* eslint-disable-next-line no-mixed-spaces-and-tabs */
</style>